import { render, staticRenderFns } from "./QuestionReview.vue?vue&type=template&id=45a6cd9f&scoped=true&"
import script from "./QuestionReview.vue?vue&type=script&lang=ts&"
export * from "./QuestionReview.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionReview.vue?vue&type=style&index=0&id=45a6cd9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6cd9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a6cd9f')) {
      api.createRecord('45a6cd9f', component.options)
    } else {
      api.reload('45a6cd9f', component.options)
    }
    module.hot.accept("./QuestionReview.vue?vue&type=template&id=45a6cd9f&scoped=true&", function () {
      api.rerender('45a6cd9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Survey/QuestionReview.vue"
export default component.exports